import React, { useState, useEffect, useMemo, useRef } from "react"
import "./TaxCatalog.scss"
import { useHistory } from "react-router"
import Button from '@mui/material/Button'

import { GlobalFilter } from "../../../../frontDesk/patientDirectory/GlobalFilter"
import { COLUMNS } from './TaxCatalogColumns'
import Dropdown from "components/DropDown"
import { useTable, useSortBy, useGlobalFilter } from 'react-table'
import { deleteCatalogTax, getTaxCatalogDetails, getCenterDetails } from "../../../../../core/services/api"
import { useSelector } from "react-redux"
import Toast from "../../../../../components/Toast"



function TaxCatalog({ onAddTaxClick, editTax }: any) {
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const [data, setData] = useState<any>([])

  const columns = useMemo(() => COLUMNS, [])
  const componentRef = useRef()
  const [displayToast, toggleDisplayToast] = useState<any>()

  const [centerDetail, setCenterDetail] = useState<any>()
  const [centerId, setCenterId] = useState<any>(userDetail?.currentCenter?.centerId)
  useEffect(() => {
    getCenterDetails().then((res: any) => {
      setCenterDetail(res);
    }).catch((err: any) => {
      console.log(err, "error")
    })

  }, [centerId])

  const dropdownCenters = centerDetail?.map((val: any) => {
    return {
      label: val?.centerName,
      value: val?.id
    }
  })


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },

    useGlobalFilter,
    useSortBy,
  )
  const { globalFilter } = state
  useEffect(() => {
    //Add center id here
    getTaxCatalogDetails(centerId)
      .then((res) => {
        setData(res)
      })
      .catch((err) => {
        console.log('err', err)
      })
  }, [centerId])

  const handleDelete = (path: any) => {
    deleteCatalogTax(`${path}`, userDetail?.currentCenter?.centerId)
      // @ts-ignore
      // @ts-ignore
      .then((res) => {
        getTaxCatalogDetails(userDetail?.currentCenter?.centerId)
          .then((res) => {
            setData(res)
            toggleDisplayToast(false)
          })
          .catch((err) => {
            console.log('err', err)
          })
      })
      .catch((err) => {
        console.log('err', err)
      })
  }

  /**
 * @param {any} path
 */
  const redirectTo = async (path: any) => {
    const editData = data.find((ele: any) => {
      return ele.id == path
    })
    onAddTaxClick()
    editTax(editData)
  }



  return (
    <div className="tax-catalog-container">
      <div className="row add-new">
        <div className="col-9"></div>
        <div className="col-3 add-new-tax">
          <Button
            className="button-container"
            onClick={() => onAddTaxClick()}
          >
            Add New Tax
          </Button>
        </div>
        <div className="search-container">
          <div>
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
          </div>
          <div style={{ width: '346px', marginRight: '40px' }}>
            <Dropdown
              selected={centerId}
              updateDropdown={(option: any) => {
                setCenterId(option);
              }}
              placeholder="Location"
              options={dropdownCenters}

            />
          </div>
        </div>
        <div>
          <table
            {...getTableProps()}
            // @ts-ignore
            ref={componentRef}
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          paddingLeft: '40px',
                        }}
                      >
                        {column.render('Header')}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody
              className="border-radiusImportant"
              {...getTableBodyProps()}
            >
              {rows.map((row) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()} style={{ cursor: 'pointer' }}>
                    {row.cells.map((cell) => {
                      return (
                        <td
                          onClick={() => {
                            if (
                              cell?.column?.id?.toLowerCase() === 'delete'
                            ) {
                              toggleDisplayToast({
                                // @ts-ignore
                                text: `Are you sure you want to delete the tax?`,
                                type: 'warning',
                                onClickText: 'Yes',
                                // @ts-ignore
                                patient: cell?.row?.original?.id,
                              })
                            }
                            if (cell?.column?.id?.toLowerCase() === 'edit') {
                              // @ts-ignore
                              redirectTo(row?.original?.id)
                            }
                          }}
                          style={{
                            maxWidth: '400px',
                            width: '400px',
                            wordWrap: 'break-word',
                            maxHeight: '100px',
                            paddingLeft: '40px',
                            verticalAlign: 'left',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontSize: '18px',
                            lineHeight: '24px',
                            letterSpacing: '1.35px',
                            textAlign: 'initial',
                            textTransform: 'lowercase',
                          }}
                          {...cell.getCellProps()}
                        >
                          {cell.render('Cell')}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </tbody>
            <tfoot>
              {footerGroups.map((footerGroup) => (
                <tr {...footerGroup.getFooterGroupProps()}>
                  {footerGroup.headers.map((column) => (
                    <td {...column.getFooterProps()}>
                      {column.render('Footer')}
                    </td>
                  ))}
                </tr>
              ))}
            </tfoot>
          </table>
        </div>
      </div>
      {displayToast && (
        <Toast
          // @ts-ignore
          textMessage={displayToast?.text}
          // @ts-ignore
          onClose={() => toggleDisplayToast(false)}
          onCloseText="Close"
          onClickText={
            // @ts-ignore
            displayToast?.onClickText ? displayToast?.onClickText : null
          }
          onClick={() =>
            // @ts-ignore
            displayToast?.patient
              ? // @ts-ignore
              handleDelete(displayToast?.patient)
              : null
          }
          // @ts-ignore
          type={displayToast?.type}
        />
      )}
    </div>
  )
}
export default TaxCatalog
